export interface PatientSatisfactionModel {
  data: number[];
  percentages: number[];
  value: number;
}

export class PatientSatisfaction {
  public data: PatientSatisfactionModel['data'];

  public percentages: PatientSatisfactionModel['percentages'];

  public value: PatientSatisfactionModel['value'];

  constructor(opts: PatientSatisfactionModel) {
    this.data = opts.data;
    this.percentages = opts.percentages;
    this.value = opts.value;
  }

  public get isEmpty() {
    return this.data.reduce((acc, c) => acc + c, 0) < 3;
  }
}
